import classNames from 'classnames'
import type { ReactElement } from 'react'
import { CardSlot } from 'app/components/pipelines/CardSlot'
import type { TaskCounts } from 'app/hooks/usePipelineTaskCounts'
import type { ContactJson } from 'app/types/entities'
import type { CardFieldId } from 'lib/cardRecipe'
import type { CardDensity } from 'lib/listCardConfig'

/** Additional details: combined multi-field list, in the white content zone. */
export function MetaSection({
  fields,
  contact,
  density,
  taskCounts,
}: {
  fields: CardFieldId[]
  contact: ContactJson
  density: CardDensity
  taskCounts?: TaskCounts
}): ReactElement {
  const compact = density === `compact`
  return (
    <div className={classNames(`flex flex-col overflow-hidden px-3`, compact ? `gap-y-0.5 pb-2` : `gap-y-1 pb-3`)}>
      {fields.map((id) => (
        <CardSlot key={id} slot="meta" fieldId={id} contact={contact} density={density} taskCounts={taskCounts} />
      ))}
    </div>
  )
}
